import { DEFAULT_SUPPORT_EMAIL } from "@lingoshade/domain";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { sharedApi } from "../../services/sharedApi";
import { toApiError } from "../../utils/errorUtils";

import type { RootState } from "../index";
import type { ContactSettings } from "@lingoshade/domain";

export const fetchContactSettings = createAsyncThunk<
  ContactSettings,
  void,
  { state: RootState; rejectValue: string }
>(
  "contact/fetch",
  async (
    _,
    { rejectWithValue },
  ): Promise<ContactSettings | ReturnType<typeof rejectWithValue>> => {
    try {
      return await sharedApi.auth.getContactSettings();
    } catch (error: unknown) {
      return rejectWithValue(toApiError(error).message);
    }
  },
  { condition: (_, { getState }): boolean => !getState().contact.loading },
);
const slice = createSlice({
  name: "contact",
  initialState: { supportEmail: DEFAULT_SUPPORT_EMAIL, loading: false },
  reducers: {},
  extraReducers: (builder): void => {
    builder
      .addCase(fetchContactSettings.pending, (state): void => {
        state.loading = true;
      })
      .addCase(fetchContactSettings.fulfilled, (state, action): void => {
        state.loading = false;
        state.supportEmail = action.payload.supportEmail;
      })
      .addCase(fetchContactSettings.rejected, (state): void => {
        state.loading = false;
      });
  },
});
export default slice.reducer;
